module.exports = __webpack_public_path__ + "static/media/04fa-standard.d17270d0.png";